"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var channel_types_1 = require("@wix/wix-vod-constants/dist/common/channel-types");
var reselect_1 = require("reselect");
var isInternalChannel = function (channel) {
    return channel.channelType === channel_types_1.CHANNEL_TYPES.CHANNEL;
};
exports.filterInternalChannels = function (channels) {
    return lodash_1.filter(channels, isInternalChannel);
};
function getChannelIds(state) {
    return state.channels.ids;
}
exports.getChannelIds = getChannelIds;
function getChannelById(state, channelId) {
    return state.entities.channels[channelId];
}
exports.getChannelById = getChannelById;
function isFetchingChannels(state) {
    return state.channels.activeRequests !== 0;
}
exports.isFetchingChannels = isFetchingChannels;
/**
 * @param state
 * @returns {Object[]} channels list
 */
exports.getChannels = reselect_1.createSelector([function (state) { return state; }, getChannelIds], function (state, ids) { return lodash_1.map(ids, lodash_1.partial(getChannelById, state)); });
exports.getChannelsInternal = reselect_1.createSelector(exports.getChannels, exports.filterInternalChannels);
exports.getAllChannelsGroupedByIds = function (state) { return state.entities.channels; };
/**
 * @param state
 * @returns {Object} {id: channel}
 */
exports.getChannelsGroupedByIds = reselect_1.createSelector([exports.getAllChannelsGroupedByIds, getChannelIds], lodash_1.pick);
/**
 * @param state
 * @returns {Object} channel
 */
exports.getChannelForWidget = reselect_1.createSelector([
    function (_a) {
        var channelInfo = _a.channelInfo;
        return lodash_1.get(channelInfo, 'info');
    },
    function (_a) {
        var channelInfo = _a.channelInfo;
        return lodash_1.get(channelInfo, 'paymentInfo');
    },
], function (info, paymentInfo) {
    if (!info && !paymentInfo) {
        return null;
    }
    return tslib_1.__assign(tslib_1.__assign({}, info), paymentInfo);
});
//# sourceMappingURL=channels.js.map